/** First three letters of the org name, used as the action ID prefix. */
export function actionDisplayPrefix(
  orgName: string | null | undefined
): string {
  const letters = (orgName ?? '').replace(/[^A-Za-z]/g, '').slice(0, 3);
  return (letters || 'ORG').toUpperCase();
}

export function formatActionDisplayId(
  orgName: string | null | undefined,
  n: number
): string {
  return `${actionDisplayPrefix(orgName)}-${n}`;
}
